




























import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch, Inject } from "vue-property-decorator";
import { RestClient } from "@elite/restclient";

@Component
export default class AjaxFileUpload extends Vue {
    @Inject()
    restClient!: RestClient;

    @Prop({ required: true })
    value!: string | null; // Uploaded file path

    get localValue() {
        return this.value;
    }
    set localValue(value: string | null) {
        this.$emit("input", value);
    }

    @Prop({ required: true, type: Number })
    promotionId!: number; // Promotion ID

    @Prop({ required: false, type: Number, default: null })
    upsellId!: number | null;

    @Prop({ required: false, type: String, default: "/api/PromotionFile" })
    apiEndpoint!: string; // API endpoint to POST

    @Prop({ required: true, type: String })
    uploadType!: string; // Upload type to send to API

    @Prop({ required: false, type: Boolean, default: false })
    isImage!: boolean;

    @Prop({ required: false, type: String, default: "image/png" })
    accept!: string;

    isLoading = false;
    file: File | null = null;
    timestamp: number = Date.now(); // Timestamp to append to image url to prevent caching

    @Watch("file", { deep: true })
    async fileUploaded(): Promise<void> {
        if (!this.file) {
            return;
        }

        this.isLoading = true;

        const formData = new FormData();
        formData.append(this.uploadType, this.file);

        const response = await this.restClient.postJson<string>(
            `${this.apiEndpoint}?promotionId=${this.promotionId}&upsellId=${this.upsellId}`,
            formData
        );

        if (response.data) {
            this.localValue = response.data;
            this.timestamp = Date.now(); // Invalidate cache
        }

        this.isLoading = false;
    }

    async deleteFile(): Promise<void> {
        if (!confirm("Are you sure you want to delete this file?")) {
            return;
        }

        this.isLoading = true;

        const response = await this.restClient.delete(
            `${this.apiEndpoint}?promotionId=${this.promotionId}&uploadType=${this.uploadType}&upsellId=${this.upsellId}`
        );

        if (response.status == 200) {
            this.file = null;
            this.localValue = null;
            this.isLoading = false;
        }
    }
}
